import "react";
import { Button, Icon } from "@therms/atalaya";
import { IoMdDownload } from "react-icons/io";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdEdit } from "react-icons/md";
//#region src/components/Buttons/index.tsx
var DownloadPdfButton = (props) => /* @__PURE__ */ jsxs(Button, {
	...props,
	className: props.className || "space-x-xxs",
	subtle: props.subtle ?? true,
	children: [
		/* @__PURE__ */ jsx(Icon, {
			Icon: IoMdDownload,
			size: props.size
		}),
		" ",
		/* @__PURE__ */ jsx("span", { children: "PDF" })
	]
});
var EditButton = (props) => /* @__PURE__ */ jsxs(Button, {
	...props,
	className: props.className || "space-x-xxs",
	subtle: props.subtle ?? true,
	children: [/* @__PURE__ */ jsx(Icon, {
		Icon: MdEdit,
		size: props.size
	}), props.label || /* @__PURE__ */ jsx("span", { children: "Edit" })]
});
//#endregion
export { DownloadPdfButton, EditButton };

//# sourceMappingURL=index.js.map